import React, { useEffect, useState } from 'react'
import { IFilter } from '../../../../../types/filter.type'
import WrapperFilter from '../WrapperFilter';
import FilterText from '../FilterText';
import FilterTextTag2 from '../FilterTextTag2';
import { cloneDeep, isArray, isString } from "lodash";
import { acceptParentheses } from "../../../../../utils/helpers";
import { ACCEPT_REGEX } from "../../../../../utils/constants";

function FilterNCSDThuoc({ loading, setCondition }: IFilter) {
  const originFilter: { [key: string]: any } = {
    ma_khoa: "",
    id_thuoc: "",
    hoat_chat: "", // multi
    ham_luong: "",
    dang_bao_che: "",
    duong_dung: "",
    dvt: "",
    nhom: "",
    ma_noi_bo: "",
    he_thuoc: "",
    ma_anh_xa: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  const handleSearchTags = (tags: any[] | string) => {
    const result: { [key: string]: any } = {};
    const andGroup = [];
    const orGroup = [];
    const notGroup = [];

    let regexAndOr = "";
    let regexNot = "[^a-zA-Z0-9\\p{L}\\s()]";
    if (isArray(tags)) {
      if (tags?.length > 0) {
        // Phân loại các tag
        for (let i = 0; i < tags.length; i++) {
          const tag = tags[i];
          switch (tag.mode) {
            case "and":
              andGroup.push(acceptParentheses(tag.value.trim()));
              break;
            case "or":
              orGroup.push(acceptParentheses(tag.value.trim()));
              break;
            default:
              notGroup.push(acceptParentheses(tag.value.trim()));
              break;
          }
        }
        if (andGroup?.length > 0 || orGroup?.length > 0) {
          // Nếu tag là loại and
          if (andGroup.length > 0) {
            regexAndOr += `${cloneDeep(andGroup).join(".*")}|${cloneDeep(
              andGroup
            )
              .reverse()
              .join(".*")}`;
          }
          // Nếu tag là loại or
          if (orGroup.length > 0) {
            regexAndOr += `${!!regexAndOr ? "|" : ""}${orGroup.join("|")}`;
          }
          result.$regex = regexAndOr;
          result.$options = "iu";
        }
        // Nếu tag là loại not
        if (notGroup.length > 0) {
          regexNot += `${notGroup.join("|")}`;
        }
        result.$not = {
          $regex: regexNot,
          $options: "iu",
        };
        return result;
      } else {
        return null;
      }
    } else if (isString(tags)) {
      const regex = acceptParentheses(tags)?.split(" ").join(ACCEPT_REGEX);
      return {
        $regex: `^${regex}$`,
        $options: "iu",
        $not: {
          $regex: regexNot,
          $options: "iu",
        },
      };
    } else {
      return null;
    }
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ma_khoa) {
      condition.ma_khoa = filter.ma_khoa?.split(" ")?.join(".*s");
    }
    if (filter.id_thuoc) {
      condition.id_thuoc = filter.id_thuoc;
    }
    if (filter.hoat_chat) {
      condition.hoat_chat = filter.hoat_chat;
    }
    if (filter.ham_luong) {
      condition.ham_luong = filter.ham_luong?.split(" ")?.join(".*s");
    }
    if (filter.dang_bao_che) {
      condition.dang_bao_che = filter.dang_bao_che?.split(" ")?.join(".*s");
    }
    if (filter.duong_dung) {
      condition.duong_dung = filter.duong_dung?.split(" ")?.join(".*s");
    }
    if (filter.dvt) {
      condition.dvt = filter.dvt?.split(" ")?.join(".*s");
    }
    if (filter.nhom) {
      condition.nhom = filter.nhom?.split(" ")?.join(".*s");
    }
    if (filter.he_thuoc) {
      condition.he_thuoc = filter.he_thuoc?.split(" ")?.join(".*s");
    }
    if (filter.ma_anh_xa) {
      condition.ma_anh_xa = filter.ma_anh_xa?.split(" ")?.join(".*s");
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Mã khoa"
        placeholder="Tìm mã khoa"
        value={filter.ma_khoa}
        onSearch={(val) => setFilter({ ...filter, ma_khoa: val })}
      />
      <FilterText
        label="ID thuốc"
        placeholder="Tìm theo id thuốc"
        value={filter.id_thuoc}
        onSearch={(val) => setFilter({ ...filter, id_thuoc: val })}
      />
      <FilterTextTag2
        label="Hoạt chất"
        placeholder="Tìm hoạt chất"
        pending={loading}
        toggleClear={toggleClear}
        onSearch={(tags) => {
          setFilter({ ...filter, hoat_chat: handleSearchTags(tags) });
        }}
      />
      <FilterText
        label="Hàm lượng"
        placeholder="Tìm theo hàm lượng"
        value={filter.ham_luong}
        onSearch={(val) => setFilter({ ...filter, ham_luong: val })}
      />
      <FilterText
        label="Dạng bào chế"
        placeholder="Tìm theo dạng bào chế"
        value={filter.dang_bao_che}
        onSearch={(val) => setFilter({ ...filter, dang_bao_che: val })}
      />
      <FilterText
        label="Đường dùng"
        placeholder="Tìm theo đường dùng"
        value={filter.duong_dung}
        onSearch={(val) => setFilter({ ...filter, duong_dung: val })}
      />
      <FilterText
        label="Đơn vị tính"
        placeholder="Tìm theo đơn vị tính"
        value={filter.dvt}
        onSearch={(val) => setFilter({ ...filter, dvt: val })}
      />
      <FilterText
        label="Nhóm"
        placeholder="Tìm theo nhóm"
        value={filter.nhom}
        onSearch={(val) => setFilter({ ...filter, nhom: val })}
      />
      <FilterText
        label="Hệ thuốc"
        placeholder="Tìm theo hệ thuốc"
        value={filter.he_thuoc}
        onSearch={(val) => setFilter({ ...filter, he_thuoc: val })}
      />
      <FilterText
        label="Mã ánh xạ bảo hiểm"
        placeholder="Tìm theo mã ánh xạ"
        value={filter.ma_anh_xa}
        onSearch={(val) => setFilter({ ...filter, ma_anh_xa: val })}
      />
    </WrapperFilter>
  );
}

export default FilterNCSDThuoc